import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../app.settings';

type RedeployTarget = 'api' | 'jobs';

@Injectable({
  providedIn: 'root',
})
export class JsonEditConfigService {
  private endpoint = AppSettings.getEndpoint();

  constructor(private http: HttpClient) {}

  redeployBackend(target: RedeployTarget = 'api') {
    return this.http.post<{ message: string }>(
      `${this.withoutTrailingSlash(this.endpoint)}/v5/admin/deployments/redeploy`,
      { target },
    );
  }

  private withoutTrailingSlash(url: string): string {
    return url.replace(/\/+$/, '');
  }
}
